import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@ui-propulsion/react-components';
import Link from 'next/link';
import styles from './glossaryTerms.module.scss';

function GlossaryTerms({ title, seeAllLink, items, isGrid }) {
  const visibleItems = isGrid ? items.slice(0, 5) : items;
  return (
    <div className={styles.glossaryTerms}>
      <div className={styles.titleWrapper}>
        <div className={styles.title}>
          {isGrid ? (
            <Link href={seeAllLink}>
              <h2 data-testid={title}>{title}</h2>
            </Link>
          ) : (
            <h1 data-testid={title}>{title}</h1>
          )}
        </div>
        {isGrid && items.length > 5 && (
          <div className={styles.allTerms}>
            <Link href={seeAllLink}>See All</Link>
          </div>
        )}
      </div>
      {items?.length > 0 && (
        <Grid container className={styles.termItems}>
          {visibleItems?.map((termItem) => {
            return (
              <Grid
                item
                key={termItem.title}
                xs={12}
                sm={isGrid ? 12 : 4}
                data-testid={termItem.title}
              >
                <Link href={termItem.path}>
                  <span>{termItem.title}</span>
                </Link>
              </Grid>
            );
          })}
        </Grid>
      )}
    </div>
  );
}
GlossaryTerms.propTypes = {
  title: '',
  seeAllLink: null,
  items: [],
  isGrid: false,
};

GlossaryTerms.propTypes = {
  title: PropTypes.string,
  seeAllLink: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      path: PropTypes.string,
    })
  ),
  isGrid: PropTypes.bool,
};

export default GlossaryTerms;
